var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:{'pl-6': !_vm.xs, 'pr-4': !_vm.xs, 'pt-4': _vm.xl, 'score-trans': true},attrs:{"flat":"","height":_vm.getCardHeight()}},[_c('right_panel_performance',{ref:"ytd_performance"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }